import * as Animation from './Animation'

export namespace WhatWeDo {
    
    export namespace Heading {
        export const horizontalTextSize: Animation.VariableValue = {
            end: 80,
            start: 30,
            endControl: 1600,   // Width in px
            startControl: 600,  // Width in px
        }
        
        export const verticalTextSize: Animation.VariableValue = {
            end: 40,
            start: 30,
            endControl: 600,    // Width in px
            startControl: 400,  // Width in px
        }

        export const isVerticalForWidthInPx = (widthInPx: number) => (widthInPx < 600)
        export const heightWhenVerticalInPx = 180
    }

    export namespace Section {
        export const widthValues: Animation.VariableValue = {
            start: 300,
            end: 600,
            startControl: 300, // Width in px
            endControl: 1200,  // Width in px
        }
        export const titleFontSizeValues: Animation.VariableValue = {
            start: 20,
            end: 30,
            startControl: 400, // Width in px
            endControl: 600,   // Width in px
        }
        export const detailFontSizeValues: Animation.VariableValue = {
            start: 14,
            end: 20,
            startControl: 340, // Width in px
            endControl: 600,   // Width in px
        }
        export const marginValues: Animation.VariableValue = {
            start: 10,
            end: 30,
            startControl: 340, // Width in px
            endControl: 600,   // Width in px
        }

        export const imageAspectRatio = 865 / 1100
        export const imageHeightForWidth = (width: number) => (width / imageAspectRatio)
        export const imageWidthForHeight = (height: number) => (height * imageAspectRatio)
        export const textHeightWhenHorizontalInPx = 280
        export const totalHeightWhenVerticalInPx = 480
        export const verticalImageTextSpacerHeightInPx = 40
        export const isVerticalForWidthInPx = (sectionWidthInPx: number) => (sectionWidthInPx < 500)
        export const heightForWidthInPx = (sectionWidthInPx: number) => {
            const isVertical = isVerticalForWidthInPx(sectionWidthInPx)
            const textHeightWhenVerticalInPx = ((totalHeightWhenVerticalInPx - verticalImageTextSpacerHeightInPx) / 2)
            return isVertical ? (textHeightWhenVerticalInPx + verticalImageTextSpacerHeightInPx + textHeightWhenVerticalInPx)   // The image should be the same height as the text in a vertical layout
                              : textHeightWhenHorizontalInPx
        }

        export const maxImageOffsetInPx = 20
    }
    
    export const spaceAboveHeadingInPx = 50
    export const spaceBelowHeadingInPx = 100
    // export const verticalSpaceBetweenSectionsInPx = 200

    export const verticalSpaceBetweenSections: Animation.VariableValue = {
        start: 50,
        end: 200,
        startControl: 300, // Width in px
        endControl: 800,  // Width in px
    }

    // export const totalHeightForWidthInPx = (widthInPx: number) => {
    //     const headingIsVertical = Heading.isVerticalForWidthInPx(widthInPx)
    //     const headingHeight = headingIsVertical ? Animation.calculateValue(Heading.verticalTextSize, widthInPx)
    //                                             : Animation.calculateValue(Heading.horizontalTextSize, widthInPx)
    //     const sectionWidthInPx = Animation.calculateValue(Section.widthValues, widthInPx)
    //     const sectionHeight = Section.heightForWidthInPx(sectionWidthInPx)
    //     const verticalSpaceBetweenSectionsInPx = Animation.calculateValue(verticalSpaceBetweenSections, widthInPx)
        
    //     const total = spaceAboveHeadingInPx + headingHeight + spaceBelowHeadingInPx
    //          + sectionHeight + verticalSpaceBetweenSectionsInPx
    //          + sectionHeight + verticalSpaceBetweenSectionsInPx
    //          + sectionHeight + verticalSpaceBetweenSectionsInPx
    //     // console.log({ headingIsVertical, spaceAboveHeadingInPx, headingHeight, spaceBelowHeadingInPx, sectionHeight, verticalSpaceBetweenSectionsInPx, total })
    //     return total
    // }
}